module.exports = __webpack_public_path__ + "img/win.6ce64f79.gif";